//import dependencies
import '../styles/output.css'
import '../styles/global.css'
import Gallery from './Thumbnail'
//Return the works section
let Works=()=>{
    return(
        <div className='main py-6 flex flex-col items-center bg-neutral-950'>
            {/* Title section below */}
            <div>
            <h3 className='font-bold text-xl py-1 mb-3 text-white'>Works</h3>
            </div>
            
            {/*Work Grid containers below (Covers,Posters,Banners) */}
            <div className='w-full flex flex-row flex-nowrap overflow-x-auto overflow-y-hidden'>
                {/* Covers Container below*/}
                <Gallery/>
            </div>
            <div>
               <a href='https://www.instagram.com/royderell.png/'>
                <button className='bg-yellow-400 font-bold p-2 my-4 round-10 IG-Link'>View More on Instagram</button>
               </a> 
            </div>
        </div>
    )
}
export default Works